module.exports = __webpack_public_path__ + "img/image_cellmate_gen301.9bedfe11.png";